import React, { useState, useEffect } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { useOutletContext } from "react-router-dom";
import { rootUrl } from "../../../helpers";

const BankReconciliation = () => {
  const [months] = useState([
    { month: "January", value: 1 },
    { month: "February", value: 2 },
    { month: "March", value: 3 },
    { month: "April", value: 4 },
    { month: "May", value: 5 },
    { month: "June", value: 6 },
    { month: "July", value: 7 },
    { month: "August", value: 8 },
    { month: "September", value: 9 },
    { month: "October", value: 10 },
    { month: "November", value: 11 },
    { month: "December", value: 12 },
  ]);

  const allData = useOutletContext();
  
  const [banks, setBanks] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedBank, setSelectedBank] = useState("");
  const [excelData, setExcelData] = useState([]);
  const [cashData, setCashData] = useState([]);
  const [missed, setMissed] = useState([]);
  const [matches, setMatches] = useState([]);
  const [onlyInDatabase, setOnlyDB] = useState([]);
  const [onlyInExcel, setOnlyExcel] = useState([]);
  
  useEffect(() => {
    // Fetch bank data
    // axios.get("/api/banks").then((response) => {
    //   setBanks(response.data);
    // });
    setBanks(allData.bank)
  }, []);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(sheet);
      setExcelData(json);
    };
    reader.readAsArrayBuffer(file);
  };

  const reconcile = async () => {
    if (!selectedMonth || !selectedBank) {
      alert("Please select a month and bank.");
      return;
    }

    try {
      const response = await axios.post(rootUrl(`/bankRec`), {month:selectedMonth, bank:selectedBank});
      const cashTransactions = response.data.trans;
      const missedEntries = [];

      const matches = cashTransactions.filter((transaction) =>
        excelData.some(
          (entry) =>
            entry.chequeno == transaction.cheque &&
            (parseFloat(entry.debit) === parseFloat(transaction.amount) ||
              parseFloat(entry.credit) === parseFloat(transaction.amount))
        )
      );
      
      const onlyInDatabase = cashTransactions.filter(
        (transaction) =>
          !excelData.some(
            (entry) =>
              entry.chequeno == transaction.cheque &&
              (parseFloat(entry.debit) === parseFloat(transaction.amount) ||
                parseFloat(entry.credit) === parseFloat(transaction.amount))
          )
      );
      
      const onlyInExcel = excelData.filter(
        (entry) =>
          !cashTransactions.some(
            (transaction) =>
              entry.chequeno == transaction.cheque &&
              (parseFloat(entry.debit) === parseFloat(transaction.amount) ||
                parseFloat(entry.credit) === parseFloat(transaction.amount))
          )
      );

      setMatches(matches)
      setOnlyDB(onlyInDatabase)
      setOnlyExcel(onlyInExcel)
      

      cashTransactions.forEach((transaction) => {
        if (transaction.type === "expense") {
          const match = excelData.find(
            (entry) =>
              entry.chequeno == transaction.cheque &&
              parseFloat(entry.debit) === parseFloat(transaction.amount)
          );
          if (!match) {
            missedEntries.push({
              date: transaction.date,
              cheque: transaction.cheque,
              amount: parseFloat(transaction.amount),
              type: "expense",
            });
          }
        } else if (transaction.type === "income") {
          const match = excelData.find(
            (entry) =>
              entry.chequeno == transaction.cheque &&
              parseFloat(entry.credit) === parseFloat(transaction.amount)
          );
          if (!match) {
            missedEntries.push({
              date: transaction.date,
              cheque: transaction.cheque,
              amount: parseFloat(transaction.amount),
              type: "income",
            });
          }
        }
      });

      setCashData(cashTransactions);
      setMissed(missedEntries);
    } catch (error) {
      console.error("Error fetching reconciliation data:", error);
    }
  };

  const displayReconciliation = () => {
    const bf = cashData[0]?.diff || 0;
    const payments = cashData
      .filter((entry) => entry.type === "expense")
      .reduce((sum, entry) => sum + parseFloat(entry.amount), 0);
    const receipts = cashData
      .filter((entry) => entry.type === "income")
      .reduce((sum, entry) => sum + parseFloat(entry.amount), 0);

    const incomeMissed = missed.filter((entry) => entry.type === "income");
    const expenseMissed = missed.filter((entry) => entry.type === "expense");

    return (
      <div>
        <h3 className="text-2xl font-bold">
          Bank Reconciliation Statement for the Month of{" "}
          {months.find((m) => m.value === parseInt(selectedMonth))?.month} 2025
        </h3>
        <table className="w-full border border-gray-300 rounded-lg shadow-lg my-6">
  <thead className="bg-blue-900 text-white">
    <tr>
      <th className="py-2 px-4 text-left">Opening Balance as per Cash Book</th>
      <th className="py-2 px-4 text-right">{bf}</th>
    </tr>
  </thead>
  <tbody className="bg-white divide-y divide-gray-200">
    <tr>
      <td className="py-2 px-4 text-left">Add Receipts</td>
      <td className="py-2 px-4 text-right">{receipts}</td>
    </tr>
    <tr>
      <td className="py-2 px-4 text-left">Less Payments</td>
      <td className="py-2 px-4 text-right">{payments}</td>
    </tr>
    <tr className="bg-gray-50">
      <td className="py-2 px-4 text-left font-semibold">Closing Balance as per Cash Book</td>
      <td className="py-2 px-4 text-right font-semibold">{bf + receipts - payments}</td>
    </tr>
  </tbody>
</table>

<h4 className="text-lg font-bold mt-6">Less Uncredited Deposits:</h4>
<table className="w-full border border-gray-300 rounded-lg shadow-lg my-4">
  <thead className="bg-blue-900 text-white">
    <tr>
      <th className="py-2 px-4 text-left">Deposit Date</th>
      <th className="py-2 px-4 text-left">GRN</th>
      <th className="py-2 px-4 text-right">Amount</th>
    </tr>
  </thead>
  <tbody className="bg-white divide-y divide-gray-200">
    {incomeMissed.map((entry, index) => (
      <tr key={index} className="hover:bg-gray-100">
        <td className="py-2 px-4 text-left">{entry.date}</td>
        <td className="py-2 px-4 text-left">{entry.cheque}</td>
        <td className="py-2 px-4 text-right">{entry.amount}</td>
      </tr>
    ))}
  </tbody>
</table>

<h4 className="text-lg font-bold mt-6">Add Unpresented Cheques:</h4>
<table className="w-full border border-gray-300 rounded-lg shadow-lg my-4">
  <thead className="bg-blue-900 text-white">
    <tr>
      <th className="py-2 px-4 text-left">Date</th>
      <th className="py-2 px-4 text-left">Cheque</th>
      <th className="py-2 px-4 text-right">Amount</th>
    </tr>
  </thead>
  <tbody className="bg-white divide-y divide-gray-200">
    {expenseMissed.map((entry, index) => (
      <tr key={index} className="hover:bg-gray-100">
        <td className="py-2 px-4 text-left">{entry.date}</td>
        <td className="py-2 px-4 text-left">{entry.cheque}</td>
        <td className="py-2 px-4 text-right">{entry.amount}</td>
      </tr>
    ))}
  </tbody>
</table>

<section className="my-6">
        <h4 className="text-lg font-bold">Matching Entries:</h4>
        <table className="w-full border border-gray-300 rounded-lg shadow-lg my-4">
          <thead className="bg-blue-900 text-white">
            <tr>
              <th className="py-2 px-4 text-left">Date</th>
              <th className="py-2 px-4 text-left">Cheque</th>
              <th className="py-2 px-4 text-right">Amount</th>
              <th className="py-2 px-4 text-left">Type</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {matches.map((entry, index) => (
              <tr key={index} className="hover:bg-gray-100">
                <td className="py-2 px-4 text-left">{entry.date}</td>
                <td className="py-2 px-4 text-left">{entry.cheque}</td>
                <td className="py-2 px-4 text-right">{entry.amount}</td>
                <td className="py-2 px-4 text-left">{entry.type}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <section className="my-6">
        <h4 className="text-lg font-bold">Only in Database:</h4>
        <table className="w-full border border-gray-300 rounded-lg shadow-lg my-4">
          <thead className="bg-blue-900 text-white">
            <tr>
              <th className="py-2 px-4 text-left">Date</th>
              <th className="py-2 px-4 text-left">Cheque</th>
              <th className="py-2 px-4 text-right">Amount</th>
              <th className="py-2 px-4 text-left">Type</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {onlyInDatabase.map((entry, index) => (
              <tr key={index} className="hover:bg-gray-100">
                <td className="py-2 px-4 text-left">{entry.date}</td>
                <td className="py-2 px-4 text-left">{entry.cheque}</td>
                <td className="py-2 px-4 text-right">{entry.amount}</td>
                <td className="py-2 px-4 text-left">{entry.type}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <section className="my-6">
        <h4 className="text-lg font-bold">Only in Excel:</h4>
        <table className="w-full border border-gray-300 rounded-lg shadow-lg my-4">
          <thead className="bg-blue-900 text-white">
            <tr>
              <th className="py-2 px-4 text-left">Date</th>
              <th className="py-2 px-4 text-left">Cheque</th>
              <th className="py-2 px-4 text-right">Amount</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {onlyInExcel.map((entry, index) => (
              <tr key={index} className="hover:bg-gray-100">
                <td className="py-2 px-4 text-left">{entry.date}</td>
                <td className="py-2 px-4 text-left">{entry.chequeno}</td>
                <td className="py-2 px-4 text-right">
                  {entry.debit || entry.credit}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      </div>
    );
  };

  return (
    <div className="w-full container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Bank Reconciliation</h1>
      <div className="grid grid-cols-2 gap-4 my-3">
        <select
          className="border rounded p-2 w-full"
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(e.target.value)}
        >
          <option value="">Select Month</option>
          {months.map((month) => (
            <option key={month.value} value={month.value}>
              {month.month}
            </option>
          ))}
        </select>
        <select
          className="border rounded p-2 w-full"
          value={selectedBank}
          onChange={(e) => setSelectedBank(e.target.value)}
        >
          <option value="">Select Bank</option>
          {banks.map((bank) => (
            <option key={bank.id} value={bank.id}>
              {bank.name}
            </option>
          ))}
        </select>
      </div>
      <input
        type="file"
        className="mb-4"
        onChange={handleFileUpload}
      />
      <button
        className="bg-blue-900 text-white py-2 px-4 rounded"
        onClick={reconcile}
      >
        Reconcile
      </button>
      <hr className="my-4" />
      {cashData.length > 0 && displayReconciliation()}
    </div>
  );
};

export default BankReconciliation;
